module.exports = __webpack_public_path__ + "static/img/logo.ff4419a8.svg";